<template>
  <admin-indexing />
</template>
<script>
import AdminIndexing from '@/components/admin/indexing/index.vue'
export default {
  components: { AdminIndexing }
}
</script>
